type WeightHighlightLabelKey =
  | "highlights.itemWeight"
  | "highlights.itemWeightSublabel"
  | "highlights.shelfWeight"
  | "highlights.shelfWeightSublabel"
  | "highlights.shelfWeightPct"
  | "highlights.shelfWeightPctSublabel"
  | "highlights.overloaded"
  | "highlights.overloadedSublabel";

export const highlightsSpecialFields: {
  label: string;
  formula: string;
  sublabel?: string;
  labelKey?: WeightHighlightLabelKey;
  sublabelKey?: WeightHighlightLabelKey;
}[] = [
  {
    label: "Price",
    formula: "price",
  },
  {
    label: "Facings",
    sublabel: "Planogram",
    formula: "facings",
  },
  {
    label: "Min days of supply",
    formula: "minDaysOfSupply",
  },
  {
    label: "Max days of supply",
    formula: "maxDaysOfSupply",
  },
  {
    label: "Quantity",
    formula: "quantity",
  },
  {
    label: "Sales amount",
    formula: "salesAmount",
  },
  {
    label: "Size",
    formula: "size",
  },
  {
    label: "Brand",
    formula: "brand",
  },
  {
    label: "Variant",
    formula: "variant",
  },
  {
    label: "Category Code",
    formula: "categoryCode",
  },
  {
    label: "Sub-Category",
    formula: "subCategory",
  },
  {
    label: "UPC",
    formula: "upc",
  },
  {
    label: "Color",
    formula: "color",
  },
  {
    label: "Orientation",
    formula: "orientation",
  },
  {
    label: "No. Units in Tray",
    formula: "noOfUnitsInTray",
  },
  {
    label: "No. Units in Case",
    formula: "noOfUnitsInCase",
  },
  {
    label: "Squeeze Width",
    formula: "squeezeWidth",
  },
  {
    label: "Squeeze Width Percentage",
    formula: "squeezeWidthPct",
  },
  {
    label: "Squeeze Height",
    formula: "squeezeHeight",
  },
  {
    label: "Squeeze Height Percentage",
    formula: "squeezeHeightPct",
  },
  {
    label: "Squeeze Depth",
    formula: "squeezeDepth",
  },
  {
    label: "Squeeze Depth Percentage",
    formula: "squeezeDepthPct",
  },
  {
    label: "Overhang Squeeze Depth Flag",
    formula: "overhangSqueezeDepthFlag",
  },
  {
    label: "CDT 1",
    formula: "cdt1",
  },
  {
    label: "CDT 2",
    formula: "cdt2",
  },
  {
    label: "CDT 3",
    formula: "cdt3",
  },
  {
    label: "Min Facings",
    formula: "minFacings",
  },
  {
    label: "Max Facings",
    formula: "maxFacings",
  },
  {
    label: "Facings Rows",
    formula: "facingsRows",
  },
  {
    label: "MOS",
    formula: "mos",
    sublabel: "Planogram",
  },
  {
    label: "DOS",
    formula: "dos",
    sublabel: "Planogram",
  },
  {
    label: "Capacity",
    formula: "capacity",
    sublabel: "Planogram",
  },
  {
    label: "MOS",
    formula: "minOnShelf",
  },
  {
    label: "Weight",
    sublabel: "lb",
    formula: "weight",
  },
  {
    label: "Bulk",
    sublabel: "8 lb+",
    formula: "bulk",
  },
  {
    label: "Item Weight",
    sublabel: "lb on shelf",
    formula: "itemWeight",
    labelKey: "highlights.itemWeight",
    sublabelKey: "highlights.itemWeightSublabel",
  },
  {
    label: "Shelf Weight",
    sublabel: "lb on board",
    formula: "shelfWeight",
    labelKey: "highlights.shelfWeight",
    sublabelKey: "highlights.shelfWeightSublabel",
  },
  {
    label: "Shelf Weight %",
    sublabel: "of limit",
    formula: "shelfWeightPct",
    labelKey: "highlights.shelfWeightPct",
    sublabelKey: "highlights.shelfWeightPctSublabel",
  },
  {
    label: "Overloaded",
    sublabel: "over limit",
    formula: "overloaded",
    labelKey: "highlights.overloaded",
    sublabelKey: "highlights.overloadedSublabel",
  },
  {
    label: "New item flag",
    formula: "newItemFlag",
  },
  {
    label: "Update operation",
    formula: "updateStatus.operation",
  },
  {
    label: "Update change type",
    formula: "updateStatus.changeType",
  },
  {
    label: "Core Range",
    formula: "inCoreRange",
  },
  {
    label: "Ranged Approved Smaller",
    formula: "rangedInBiggerOrSmallerStores.approvedSmaller",
  },
  {
    label: "Ranged All Smaller",
    formula: "rangedInBiggerOrSmallerStores.allSmaller",
  },
  {
    label: "Ranged Approved Bigger",
    formula: "rangedInBiggerOrSmallerStores.approvedBigger",
  },
  {
    label: "Ranged All Bigger",
    formula: "rangedInBiggerOrSmallerStores.allBigger",
  },
];

export const insertedItemHighlightFormula =
  'updateStatus.operation === "INSERT" && updateStatus.changeType === "INSERTED"';

export const highlightsOperators = [
  { label: "+", formula: "+" },
  { label: "-", formula: "-" },
  { label: "*", formula: "*" },
  { label: "/", formula: "/" },
  { label: "(", formula: "(" },
  { label: ")", formula: ")" },
  { label: "=", formula: "===" },
  { label: "<", formula: "<" },
  { label: ">", formula: ">" },
  { label: "<=", formula: "<=" },
  { label: ">=", formula: ">=" },
  { label: "true", formula: "true" },
  { label: "false", formula: "false" },
  { label: "and", formula: "&&" },
  { label: "or", formula: "||" },
];

export const isHighlightsSpecialFieldFormula = (formula: string) =>
  highlightsSpecialFields.some((field) => field.formula.toLowerCase() === formula.toLowerCase());
